import { Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import {
  IconBuildingBank,
  IconChevronRight,
  IconCreditCard,
} from "@tabler/icons-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Text from "../../components/ui/Text";
import { useAuth } from "../../contexts/AuthContext";
import { StripeConnectDialog } from "../games/CreateGame/parts/GameStep/parts/PaymentCollection/parts";

const Payments = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const isStripeConnected = currentUser?.stripe_connected;

  const [isStripeDialogOpen, setIsStripeDialogOpen] = useState(false);

  const handleNavigation = (path) => {
    navigate(path);
  };

  // Desktop layout with tabs
  return (
    <>
      {/* Page Header */}
      <Text variant="pageHeader" sx={{ mb: 3 }}>
        Payments
      </Text>

      {/* Payment Options List */}
      <Box
        sx={{
          borderRadius: 2,
          p: { xs: 0, md: 3 },
          border: { xs: "none", md: "1px solid #E5E5E5" },
          backgroundColor: { xs: "transparent", md: "white" },
        }}
      >
        <List
          sx={{ p: 0, display: "flex", flexDirection: "column", gap: "16px" }}
        >
          <ListItem
            onClick={() => handleNavigation("/payments/my-payments")}
            sx={{
              p: "8px",
              border: "1px solid #D4D4D4",
              borderRadius: "4px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#F6F6F6",
              },
            }}
          >
            <ListItemIcon
              sx={{
                color: "black",
                minWidth: "0 !important",
                mr: "12px",
                backgroundColor: "#F5F5F5",
                borderRadius: "50%",
                padding: "8px",
                height: "32px",
                width: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconCreditCard size={24} />
            </ListItemIcon>
            <ListItemText
              primary="My payments"
              secondary="View payment methods and receipts for games you played"
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#000",
                },
                "& .MuiListItemText-secondary": {
                  fontSize: "14px",
                  fontWeight: 400,
                },
              }}
            />
            <IconChevronRight size={24} color="#000" />
          </ListItem>
          <ListItem
            onClick={() =>
              isStripeConnected
                ? handleNavigation("/payments/earnings")
                : setIsStripeDialogOpen(true)
            }
            sx={{
              p: "8px",
              border: "1px solid #D4D4D4",
              borderRadius: "4px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#F6F6F6",
              },
            }}
          >
            <ListItemIcon
              sx={{
                color: "black",
                minWidth: "0 !important",
                mr: "12px",
                backgroundColor: "#F5F5F5",
                borderRadius: "50%",
                padding: "8px",
                height: "32px",
                width: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconBuildingBank size={24} />
            </ListItemIcon>
            <ListItemText
              primary="Earnings and payouts"
              secondary="View earnings and payouts for games you played"
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#000",
                },
                "& .MuiListItemText-secondary": {
                  fontSize: "14px",
                  fontWeight: 400,
                },
              }}
            />
            <IconChevronRight size={24} color="#000" />
          </ListItem>
        </List>
      </Box>
      <StripeConnectDialog
        open={isStripeDialogOpen}
        onClose={() => setIsStripeDialogOpen(false)}
      />
    </>
  );
};

export default Payments;
